import { Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export interface IContactUsMainBannerProps {
  borderPosition: "top" | "bottom" | "none";
}

export const ContactUsMainBannerDesktop: React.FC<
  IContactUsMainBannerProps
> = ({ borderPosition }) => {
  const { isDesktopAndAbove } = useViewport();
  const imageUrl = optimizeImageUrl(
    {
      url: isDesktopAndAbove
        ? "https://cdn.faire.com/fastly/4c971e1e45f4e1cb8ad1201d3c6e6f49538e500be7877b00185640facd8bac96.png"
        : "https://cdn.faire.com/fastly/bc3a24708a6766f52ec6970ec31865c9a2fffec70e38df724c25a2cde12cb251.png",
    },
    false
  );

  return (
    <Wrapper>
      {borderPosition === "top" ? (
        <>
          <Border />
          <Spacer height="6x" />
        </>
      ) : null}

      <ColorWrapper>
        <ImageWrapper>
          <img src={imageUrl} />
        </ImageWrapper>
        <Spacer width="6x" />
        <ContentWrapper>
          <Typography variant="pageHeaderSerifRegular">
            <StrictLocalMsg
              defaultMessage="Need more help?"
              description={{
                text: "Title for need more help",
                img: "https://cdn.faire.com/fastly/32017940357dace8aa27c3cb6f98822584f8bdf7470a0d550691d7d1d443e2ee.png",
              }}
            />
          </Typography>
          <Spacer height="1x" />
          <Typography variant="paragraphSansRegular">
            <StrictLocalMsg
              defaultMessage="Share more about your issue, and get in touch with our support team."
              description={{
                text: "Message about what to do if more help is needed.",
                img: "https://cdn.faire.com/fastly/3e55217625248fa1388f8246c70c4bd380b57a17dc3847db3d3312f1874c5561.png",
              }}
            />
          </Typography>
          <Spacer height="2x" />
          <StyledContactUsButton
            source={SelfServeSource.CONTACT_US_FOOTER_BANNER}
          />
        </ContentWrapper>
      </ColorWrapper>
      {borderPosition === "bottom" ? (
        <>
          <Spacer height="6x" />
          <Border />
        </>
      ) : null}
    </Wrapper>
  );
};

const Wrapper = styled(Column).attrs({ justify: "center", align: "center" })`
  padding: ${getSpacing("7x")};
`;

const ColorWrapper = styled(Row)`
  background-color: ${Decorative.tint.orange};
  width: 100%;
  max-width: 1500px;
  padding: ${getSpacing("4x")};
`;

const ImageWrapper = styled(Column)`
  width: 50%;
`;

const Border = styled(HorizontalLine)`
  max-width: 1500px;
`;

const ContentWrapper = styled(Column).attrs({ justify: "center" })`
  background-color: ${Decorative.tint.orange};
`;

const StyledContactUsButton = styled(ContactUsButton)`
  width: 200px;
`;
